<div class="mx-auto max-w-2xl px-4 py-8 sm:px-6 lg:px-8">
  <a routerLink="/support" class="text-sm font-medium text-secondary hover:text-primary">
    ← Back to support
  </a>

  <div class="mt-4 rounded-2xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 p-6 shadow-sm sm:p-8">
    <h1 class="text-2xl font-semibold text-primary">Open a support ticket</h1>
    <p class="mt-2 text-sm leading-6 text-secondary">
      Describe your issue and choose how you'd like to be notified when we reply.
    </p>

    <form class="mt-8 space-y-6" (ngSubmit)="submit()">
      <div>
        <label for="category" class="block text-sm font-medium text-primary">Category</label>
        <select
          id="category"
          name="category"
          [(ngModel)]="category"
          required
          class="mt-1 block w-full rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 px-3 py-2 text-primary shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary">
          <option value="" disabled>Select category</option>
          @for (option of categoryOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div>
        <label for="subject" class="block text-sm font-medium text-primary">Subject</label>
        <input
          id="subject"
          name="subject"
          type="text"
          [(ngModel)]="subject"
          maxlength="200"
          class="mt-1 block w-full rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 px-3 py-2 text-primary shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary" />
      </div>

      <div>
        <label for="message" class="block text-sm font-medium text-primary">Message</label>
        <textarea
          id="message"
          name="message"
          rows="8"
          [(ngModel)]="message"
          maxlength="5000"
          class="mt-1 block w-full rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 px-3 py-2 text-primary shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"></textarea>
      </div>

      <div>
        <label class="block text-sm font-medium text-primary">Attachments</label>
        <app-support-attachment-input
          class="mt-2 block"
          [attachments]="attachments"
          (attachmentsChange)="onAttachmentsChange($event)"></app-support-attachment-input>
      </div>

      <app-support-alert-preferences-input
        [alertPreferences]="alertPreferences"
        [hasPushDevice]="hasPushDevice()"
        (alertPreferencesChange)="onAlertPreferencesChange($event)"></app-support-alert-preferences-input>

      @if (error()) {
        <p class="text-sm text-red-600">{{ error() }}</p>
      }

      <div class="mt-6 flex gap-3">
        <button type="submit" [disabled]="submitting()" class="btn-basic-sm btn-primary disabled:opacity-50">
          {{ submitting() ? 'Sending...' : 'Submit ticket' }}
        </button>
        <a routerLink="/support" class="btn-basic-sm btn-secondary">Cancel</a>
      </div>
    </form>
  </div>
</div>
